import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import DtoDetailCompanyOvertimeRule_OvertimeRule from "./DtoDetailCompanyOvertimeRule_OvertimeRule";
import UiGroup from "./UiGroup";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailCompanyOvertimeRule extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
        this.OvertimeRules = [];
    }

    [proName: string]: any;
    /**
     * 待办时效规则
     */
    OvertimeRules?: DtoDetailCompanyOvertimeRule_OvertimeRule[];
}

/**
 * -表单校验
 */
export const DtoDetailCompanyOvertimeRuleRules = {
}

/**
 * -设置项
 */
export const DtoDetailCompanyOvertimeRuleMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "OvertimeRules",
    Label: "待办时效规则",
    Customize: true,
  },
]
